module.exports = __webpack_public_path__ + "static/media/oilBarrel.b1fdda4d.svg";